import api from './api';

/**
 * Profile Service (Admin)
 * Handles admin profile API calls
 */
const profileService = {
    /**
     * Get admin profile
     * @returns {Promise<Object>}
     */
    getProfile: async () => {
        return api.get('/admin/profile');
    },

    /**
     * Update admin profile
     * @param {Object} data - Profile data (name, email, phone)
     * @returns {Promise<Object>}
     */
    updateProfile: async (data) => {
        return api.patch('/admin/profile', data);
    },

    /**
     * Upload admin avatar
     * @param {File} file - Avatar file
     * @returns {Promise<Object>}
     */
    uploadAvatar: async (file) => {
        const formData = new FormData();
        formData.append('avatar', file);
        return api.patchMultipart('/admin/profile', formData);
    },

    /**
     * Change admin password
     * @param {Object} data - Password data (currentPassword, newPassword)
     * @returns {Promise<Object>}
     */
    changePassword: async (data) => {
        return api.patch('/admin/profile/password', data);
    },

    /**
     * Get all settings (notifications, preferences)
     * @returns {Promise<Object>}
     */
    getSettings: async () => {
        return api.get('/admin/profile/settings');
    },

    /**
     * Update notification settings
     * @param {Object} settings - Notification settings
     * @returns {Promise<Object>}
     */
    updateNotificationSettings: async (settings) => {
        return api.patch('/admin/profile/notifications', settings);
    },

    /**
     * Update preferences (language)
     * @param {Object} preferences - Admin preferences
     * @returns {Promise<Object>}
     */
    updatePreferences: async (preferences) => {
        return api.patch('/admin/profile/preferences', preferences);
    },

    getSiteSettings: async () => {
        return api.get('/admin/settings');
    },

    updateSiteSettings: async (data) => {
        return api.put('/admin/settings', data);
    }
};

export default profileService;
